/**
 * Formats an array of inmate aliases into a semicolon-separated string (or 'n/a' if empty).
 */
export function formatAliases(aliases: any[] | null | undefined): string {
  if (!aliases || !Array.isArray(aliases) || aliases.length === 0) {
    return 'n/a';
  }

  const names = aliases
    .map((alias: any) => {
      if (typeof alias === 'string') {
        return alias.trim();
      }
      if (alias && typeof alias === 'object') {
        if (alias.fullName && String(alias.fullName).trim()) {
          return String(alias.fullName).trim();
        }
        const parts = [alias.firstName, alias.middleName, alias.lastName, alias.suffix]
          .filter((p: any) => p && String(p).trim());
        if (parts.length > 0) {
          return parts.join(' ');
        }
      }
      return '';
    })
    .filter((name: string) => name.length > 0);

  return names.length > 0 ? names.join('; ') : 'n/a';
}